import { render, staticRenderFns } from "./FormCharacterization.vue?vue&type=template&id=533a3824"
import script from "./FormCharacterization.vue?vue&type=script&lang=js"
export * from "./FormCharacterization.vue?vue&type=script&lang=js"
import style0 from "./FormCharacterization.vue?vue&type=style&index=0&id=533a3824&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports